var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgHeart = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 200 200",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(100 100)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(-50 -50)",
    fill: "tomato",
    d: "M92.71,7.27L92.71,7.27c-9.71-9.69-25.46-9.69-35.18,0L50,14.79l-7.54-7.52C32.75-2.42,17-2.42,7.29,7.27v0 c-9.71,9.69-9.71,25.41,0,35.1L50,85l42.71-42.63C102.43,32.68,102.43,16.96,92.71,7.27z"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    values: "1; 1.5; 1.25; 1.5; 1.5; 1;",
    dur: "1s",
    repeatCount: "indefinite",
    additive: "sum"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgHeart, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/heart.108cf375.svg";
export { ForwardRef as ReactComponent };